/**
 *  We initalize main object, add modules, components and initialize config..
 *  Main things is going on in config.js, DataService.js, run.js and user-store.js
 *  read comments in this file to start with..
 *
 *  Main concept is that we use routes (defined in config.js) to show views from views/angular/views folder.. In those views,
 *  we have markup for our angular components, which consist of js code placed in js/angular/components and they are using
 *  templates from views as well.
 *  For working with user we use "ngStorage-user" which is saved in browser in "Session Storage".. All data for user like
 *  name and so on are stored in this object before user creates the login.. After login is created,
 *  user data is saved in laravel database..
 *  In DataService we define api object methods, which call Laravel API to get the data about users from Database..
 *  There are also methods for saving users..
 *  Read more documentation in config.js, run.js, DataService.js and user-store.js files.
 *
 *  For more information - read "How basic code works.." section in "Documentation - jobhaj.com.txt" document
 */
angular.element(document).ready(function (event) {

    // include Angular modules.
    var modules = [];
    modules.push('ngAria');     // needed for ngMaterial module (not sure)
    modules.push('ngMaterial'); // modules used as a main frontend library, where a lot of
    modules.push('ngAnimate');  // used to animate pages and views - look in youtube how this module can be used
    modules.push('ngRoute');    // default angularJs routing module
    modules.push('ngStorage');  // module for using Session Storage of the browser..
    modules.push('satellizer'); // used for authentication, so user can login and so on..
    modules.push('flux');       // module we use flux top call different functions throughout the application - look more on YouTube

    angular.module('demo-app', modules) // add modules to app..

        // set configuration for our angular object..
        //read config/config.js file where we set routes for the application and so on..
        .config(config)

        // Flux
        // we use flux top call different functions throughout the application
        // so we can call flux.dispatch('GET_USER'); functions for this actions are set in stores/user-store.js file
        // like store.handlers[actions.GET_USER] = 'getUser'; After this getUser is just a function in stores/user-store.js file
        .value('actions', {
            AUTHENTICATE_USER: 'AUTHENTICATE_USER',
            GET_USER: 'GET_USER',
            UPDATE_USER: 'UPDATE_USER',
            SAVE_APPLICATION: 'SAVE_APPLICATION',
            LOGOUT_USER: 'LOGOUT_USER',
            DELETE_USER: 'DELETE_USER',
        })

        .directive('login', login)
        .directive('menu', menu)
        .directive('momentize', momentize)
        .directive('keepScrollPos', keepScrollPos)
        .directive('passwordMatch', passwordMatch)
        .directive('videoResizer', videoResizer)
        .directive('scrollTo', scrollTo)
        .directive('compile', ['$compile', compileHtmlWithDirectives])
        // all components are placed in js/angular/components
        .component('applicationImage', applicationImage)
        .component('applicationInfo', applicationInfo)
        .component('applicationInterests', applicationInterests)
        .component('applicationExperience', applicationExperience)
        .component('applicationLanguages', applicationLanguages)
        .component('applicationLook', applicationLook)
        .component('applicationMotivation', applicationMotivation)
        .component('applicationPersonality', applicationPersonality)
        .component('applicationWorkhours', applicationWorkhours)
        .component('controlBar', controlBar)
        .component('infoForm', infoForm)
        .component('interestsForm', interestsForm)
        .component('jobhajApplication', jobhajApplication)
        .component('jobhajDialog', jobhajDialog)
        .component('jobhajProfile', jobhajProfile)
        .component('languagesForm', languagesForm)
        .component('motivationForm', motivationForm)
        .component('photoUploader', photoUploader)
        .component('smileyForm', smileyForm)
        .component('stepIndicator', stepIndicator)
        .controller('DialogCtrl', DialogCtrl)
        .controller('HelpDialogCtrl', HelpDialogCtrl)
        .controller('showJobMapDialogCtrl', showJobMapDialogCtrl)
        // .controller('SendDialogCtrl', SendDialogCtrl)
        .factory('Breakpoints', Breakpoints)
        .factory('DataService', DataService)
        .factory('Tracking', Tracking)
        // run stores/user-store.js file..
        // or more correctly said, we set store object for angular to a object, which is returned by userStore function,
        // which is placed in stores/user-store.js file
        .store('userStore', userStore)
        .animation('.intro', intro)
        // finally we call config/run.js file
        // there we save all functions, which is running on application load - check if user is authenticated and so on
        .run(run);

    // Bootstrap manually
    angular.bootstrap(document.getElementById('ng-app'), ['demo-app']);
});